<template>
  <DialogFull
    :data="dialogSettings"
    @close="close"
    :steps="steps"
    progress
    @onStepBack="stepBack"
  >
    <template v-slot:dialog.body>
      <div class="container col-lg-8 col-sm-12">
        <Diversity
          ref="diversitySteps"
          @onFinishEditingProfile="close"
          submitButtonTitle="Save Changes"
          @onStepChanged="handleStepChanged"
          isEditMode
        />
      </div>
    </template>
  </DialogFull>
</template>

<script>
import DialogFull from "@/components/common/DialogFull";
import { USERS_NAMESPACE } from "@/store/modules/users";
import Diversity from "@/views/profile/QuestionsAndAnswers/steps/Diversity/Diversity";
import { createNamespacedHelpers } from "vuex";
import { FETCH_USER_DIVERSITY_TRAITS } from "@/store/modules/users/actions";
import { AUTH_NAMESPACE } from "@/store/modules/auth";

const { mapActions } = createNamespacedHelpers(USERS_NAMESPACE);
const { mapState: mapAuthState } = createNamespacedHelpers(AUTH_NAMESPACE);

export default {
  components: {
    DialogFull,
    Diversity
  },
  props: {
    isOpen: Boolean
  },
  data() {
    return {
      steps: {
        current: 1,
        total: 8
      }
    };
  },
  computed: {
    ...mapAuthState({
      userData: state => state.userData
    }),
    dialogSettings() {
      return {
        dialog: this.isOpen,
        title: "Diversity"
      };
    }
  },
  methods: {
    ...mapActions({
      fetchUserDiversityTraits: FETCH_USER_DIVERSITY_TRAITS
    }),
    close() {
      this.fetchUserDiversityTraits(this.userData.id);
      this.$emit("close");
    },
    handleStepChanged({ step, totalSteps }) {
      this.steps.current = step;
      this.steps.total = totalSteps;
    },
    stepBack() {
      this.$refs.diversitySteps.stepBack();
    }
  }
};
</script>

<style lang="scss"></style>
